import { brandViewer } from './roles/brand-viewer';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PageAccesses } from '../../guards/page-accesses.model';
import { configStbEditor } from './roles/config-stb-editor';
import { configStbViewer } from './roles/config-stb-viewer';
import { contentGroupEditor } from './roles/content-group-editor';
import { contentGroupViewer } from './roles/content-group-viewer';
import { godAccess } from './roles/god-access';
import { menuEditor } from './roles/menu-editor';
import { menuViewer } from './roles/menu-viewer';
import { noAccess } from './roles/no-access';
import { pageEditor } from './roles/page-editor';
import { pageViewer } from './roles/page-viewer';
import { brandEditor } from './roles/brand-editor';
import { configStreamingEditor } from './roles/config-streaming-editor';
import { configStreamingViewer } from './roles/config-streaming-viewer';
import { redirectPoliciesEditor } from './roles/redirect-policies-editor';
import { redirectPoliciesViewer } from './roles/redirect-policies-viewer';
import { onDemandContentGroupEditor } from './roles/ondemand-content-group-editor';
import { onDemandContentGroupViewer } from './roles/ondemand-content-group-viewer';
import { osntvStoreContentGroupViewer } from './roles/osntv-store-content-group-viewer';
import { osntvStoreContentGroupEditor } from './roles/osntv-store-content-group-editor';
@Injectable({
  providedIn: 'root',
})
export class PageAccessesService {
  private usersRoles = [];
  private pageAccesses: Array<PageAccesses> = [];
  private userPageAccesses: PageAccesses;
  public usersPageAccesses$ = new BehaviorSubject<PageAccesses>(null);

  constructor() {}

  public setUsersPageAccesses(roles: string[]): void {
    this.usersRoles = roles;
    this.userPageAccesses = this.usersPageAccesses$.value ?? JSON.parse(JSON.stringify(noAccess));
    this.setPageAccesses();
    this.setUserPageAccesses();
    this.usersPageAccesses$.next(this.userPageAccesses);
  }

  private setUserPageAccesses(): void {
    this.pageAccesses.forEach((pageAccesses) => {
      Object.keys(pageAccesses.menuItem).forEach((key) => {
        if (pageAccesses.menuItem[key]) {
          this.userPageAccesses.menuItem[key] = true;
        }
      });
      Object.keys(pageAccesses.screen).forEach((screen) => {
        Object.keys(pageAccesses.screen[screen]).forEach((key) => {
          if (pageAccesses.screen[screen][key]) {
            this.userPageAccesses.screen[screen][key] = true;
          }
        });
      });
      Object.keys(pageAccesses.tenantIndependentMenuItem).forEach((key) => {
        if (pageAccesses.tenantIndependentMenuItem[key]) {
          this.userPageAccesses.tenantIndependentMenuItem[key] = true;
        }
      });
      Object.keys(pageAccesses.tenantIndependentScreen).forEach((screen) => {
        Object.keys(pageAccesses.tenantIndependentScreen[screen]).forEach((key) => {
          if (pageAccesses.tenantIndependentScreen[screen][key]) {
            this.userPageAccesses.tenantIndependentScreen[screen][key] = true;
          }
        });
      });
    });
  }

  private setPageAccesses(): void {
    this.pageAccesses = [];
    this.usersRoles.forEach((role) => {
      switch (role) {
        case 'PageEditor':
          this.pageAccesses.push(pageEditor);
          break;
        case 'ContentGroupEditor':
          this.pageAccesses.push(contentGroupEditor);
          break;
        case 'MenuEditor':
          this.pageAccesses.push(menuEditor);
          break;
        case 'ConfigEditor':
          this.pageAccesses.push(configStbEditor);
          break;
        case 'StreamingConfigEditor':
          this.pageAccesses.push(configStreamingEditor);
          break;
        case 'PageViewer':
          this.pageAccesses.push(pageViewer);
          break;
        case 'ContentGroupViewer':
          this.pageAccesses.push(contentGroupViewer);
          break;
        case 'MenuViewer':
          this.pageAccesses.push(menuViewer);
          break;
        case 'ConfigViewer':
          this.pageAccesses.push(configStbViewer);
          break;
        case 'StreamingConfigViewer':
          this.pageAccesses.push(configStreamingViewer);
          break;
        case 'BrandEditor':
          this.pageAccesses.push(brandEditor);
          break;
        case 'BrandViewer':
          this.pageAccesses.push(brandViewer);
          break;
        case 'RedirectPolicyEditor':
          this.pageAccesses.push(redirectPoliciesEditor);
          break;
        case 'RedirectPolicyViewer':
          this.pageAccesses.push(redirectPoliciesViewer);
          break;
        case 'OndemandContentGroupEditor':
          this.pageAccesses.push(onDemandContentGroupEditor);
          break;
        case 'OndemandContentGroupViewer':
          this.pageAccesses.push(onDemandContentGroupViewer);
          break;
        case 'OsntvStoreContentGroupViewer':
          this.pageAccesses.push(osntvStoreContentGroupViewer);
          break;
        case 'OsntvStoreContentGroupEditor':
          this.pageAccesses.push(osntvStoreContentGroupEditor);
          break;
        case 'God':
          this.pageAccesses.push(godAccess);
          break;
      }
    });
  }
}
